import { IndserObject, IndsertPosition } from "../core/IndserObject";
import { DBEntity } from "../CadEngine";

interface DrawOperationMovePointBeforeParams {
  ray: THREE.Ray;
  array: IndserObject[];
  tol: number;
}

interface DrawOperationMovePointParams {
  point: THREE.Vector3;
  geo: any;
  position: IndsertPosition;
  obejct?: DBEntity[] | THREE.Object3D[];
}

interface IDrawOperation {
  /**
   * 过滤相交的元素
   * @param array
   */
  OnMovePointBefore(params: DrawOperationMovePointBeforeParams): void;
  OnMovePoint(point: DrawOperationMovePointParams): void;
  OnDownPoint(point: DrawOperationMovePointParams): void;
  onMouseMove(e: PointerEvent): void;
  onKeyDown(e: KeyboardEvent): void;
  onKeyUp(e: KeyboardEvent): void;
  OnZoom(camera: THREE.Camera): void;
  // GetPoints(): THREE.Vector3[];
  Finish(operate: DrawOperateState): any;
  OnWheel(e: WheelEvent): void;
}

/**
 * 结束状态
 */
enum DrawOperateState {
  complete,
  cancel,
}

export {
  IDrawOperation,
  DrawOperateState,
  DrawOperationMovePointBeforeParams,
  DrawOperationMovePointParams,
};
